import DictionaryForm from '@/modules/Dictionary/__form';
import {
  setItemCode,
  setItemName,
  setItemNameLat,
  setItemNameTranslit,
} from '@/modules/Dictionary/__form/item';
import FNumber from '@/plugins/form/FNumber';
import FCheckbox from '@/plugins/form/FCheckbox';

export default class DictionaryRoomAccommodationForm extends DictionaryForm {
  static permission = {
    add: [115],
    edit: [348],
    view: [115],
    remove: [349],
  };

  dictionary = 'roomAccomodation';

  constructor(props = {}) {
    super(props);
    setItemName.bind(this)({ length: 70 });
    setItemNameLat.bind(this)({ length: 70 });
    setItemNameTranslit.bind(this)({ length: 70 });
    setItemCode.bind(this)();
    this.setItemPlaces();
    this.setItemPlacesExt();
    this.setItemAgeFrom();
    this.setItemAgeTo();
    this.setItemIsMain();
  }

  setItemPlaces() {
    this.places = new FNumber({
      name: 'Places',
      label: 'Основных мест',
    });
    this.setItem('places', this.places);
  }

  setItemPlacesExt() {
    this.placesExt = new FNumber({
      name: 'PlacesExt',
      label: 'Дополнительных мест',
    });
    this.setItem('placesExt', this.placesExt);
  }

  setItemIsMain() {
    this.main = new FCheckbox({
      name: 'IsMain',
      placeholder: 'Основной',
    });
    this.setItem('main', this.main);
  }

  setItemAgeFrom() {
    this.ageFrom = new FNumber({
      name: 'AgeFrom',
      label: 'Возраст с',
    });
    this.setItem('ageFrom', this.ageFrom);
  }

  setItemAgeTo() {
    this.ageTo = new FNumber({
      name: 'AgeTo',
      label: 'Возраст по',
    });
    this.setItem('ageTo', this.ageTo);
  }
}
